













































































import {Vue, Component, Prop} from "vue-property-decorator";
import {EventBus} from "@/helpers/event-bus";

@Component({})
export default class SurveyFooter extends Vue {
    @Prop() currentTabName!: string;

    previous() {
        this.$emit("nextTab", "back");
        window.scrollTo(0, 0);
    }

    next() {
        EventBus.$emit("next-tab");
    }

    setUpSave() {
        EventBus.$emit("save-progress");
    }

    goToResults() {
        EventBus.$emit("go-to-results");
    }
}
